import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<string, DetachedRouteHandle>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return route.data['reuseRoute'] === true;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const id = this.getRouteId(route);
    this.storedRoutes.set(id, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const id = this.getRouteId(route);
    return this.storedRoutes.has(id);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const id = this.getRouteId(route);
    return this.storedRoutes.get(id) || null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  private getRouteId(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(v => v.routeConfig?.path || '')
      .filter(path => path)
      .join('/');
  }
}